import React, { useState } from 'react';
import { SearchComponent } from './SearchComponent';
import { RSSFeed } from './RSSFeed';
import '../styles/landing.css';

interface LandingPageProps {
  source: 'arxiv' | 'crossref';
}

export const LandingPage: React.FC<LandingPageProps> = ({ source }) => {
  const [showResults, setShowResults] = useState(false);
  const [searchParams, setSearchParams] = useState({});

  // Reset search when source changes
  React.useEffect(() => {
    setShowResults(false);
    setSearchParams({});
  }, [source]);

  const handleSearch = (keywords: string, yearFrom: string, yearTo: string) => {
    const params: any = {};
    if (keywords.trim()) params.keywords = keywords;
    if (yearFrom) params.yearFrom = yearFrom;
    if (yearTo) params.yearTo = yearTo;

    setSearchParams(params);
    setShowResults(true);
  };

  const handleBackToSearch = () => {
    setShowResults(false);
    setSearchParams({});
  };

  const sourceName = source === 'arxiv' ? 'ArXiv' : 'CrossRef';

  if (showResults) {
    return (
      <div className="landing-container">
        <div className="search-results-header">
          <button className="back-button" onClick={handleBackToSearch}>
            ← Back to Search
          </button>
          <h2>Search Results from {sourceName}</h2>
        </div>
        <RSSFeed searchParams={searchParams} source={source} />
      </div>
    );
  }

  return (
    <div className="landing-container">
      <section className="hero-section">
        <h1>Welcome to Research Blog</h1>
        <p>Discover cutting-edge research from {sourceName}</p>
        <p className="subtitle">Search for papers by keywords and publication year</p>
      </section>

      <section className="search-section">
        <SearchComponent onSearch={handleSearch} loading={false} source={source} />
      </section>

      <section className="features">
        <div className="feature-card">
          <div className="feature-icon">📚</div>
          <h3>Latest Papers</h3>
          <p>Stay updated with the newest research publications from {sourceName}</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">🔍</div>
          <h3>Advanced Search</h3>
          <p>Search by keywords and filter by publication year range</p>
        </div>
        <div className="feature-card">
          <div className="feature-icon">⚡</div>
          <h3>Quick Access</h3>
          <p>Direct links to full papers and detailed abstracts on {sourceName}</p>
        </div>
      </section>
    </div>
  );
};